import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Container, Row, Col } from 'reactstrap';
import { createHashHistory } from 'history';
import AddReportModal from './addReportModal';
import ReportPagingTable from './reportPagingTable';
import ListPanel from '../common/containers/listPanel';
import ReportsBulkActions from './reportsBulkActions';
import ReportsRow from './reportsRow';
import ReportFilterPanel from './reportFilterPanel';
import { getIsPermittedWithNoneOfThesePermissions, getIsPermittedWithAnyOfThesePermissions, isCreator } from '../common/classes/permissions';
import { checkPermission } from '../../../behaviors/src/lib/permissions';
const hashHistory = createHashHistory();
export default class Reports extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleAddHide = this.handleAddHide.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.state = {
      showAddModal: false
    };
  }

  /**
   *  Only load report types once on mounting
   */
  componentDidMount() {
    // @NOTE All users can view the reports grid
    const _this$props = this.props,
      indexQuery = _this$props.report.indexQuery,
      serverIndex = _this$props.reportActions.serverIndex,
      dynamicReportTypes = _this$props.dynamicReportTypes,
      reportTypeFilterAddActions = _this$props.reportTypeFilterAddActions,
      reportTypeFilterAdd = _this$props.reportTypeFilterAdd,
      displaySettings = _this$props.displaySettings,
      displaySettingsActions = _this$props.displaySettingsActions;
    serverIndex(indexQuery);
    // load report types
    if (!dynamicReportTypes.list.length && !dynamicReportTypes.loading) {
      reportTypeFilterAddActions.serverIndex(reportTypeFilterAdd.indexQuery);
    }
    if (displaySettings.list.length === 0) {
      displaySettingsActions.serverIndex(displaySettings.indexQuery);
    }
  }

  /* eslint-disable react/sort-comp, camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    /* eslint-enable react/sort-comp, camelcase */
    // new report created, automatically edit it
    if (nextProps.report.newReportID) {
      hashHistory.push("/reports/edit/".concat(nextProps.report.newReportID));
    }
  }
  handleAdd() {
    this.setState({
      showAddModal: true
    });
  }
  handleAddHide() {
    this.setState({
      showAddModal: false
    });
  }
  handleClick(id) {
    const reportActions = this.props.reportActions;
    reportActions.showCancel();
    hashHistory.push("/reports/".concat(id));
  }
  handleEditClick(id) {
    const reportActions = this.props.reportActions;
    reportActions.showCancel();
    hashHistory.push("/reports/edit/".concat(id));
  }
  handleSelect(id, event) {
    const reportActions = this.props.reportActions;
    if (event.target.checked) {
      reportActions.select(id);
    } else {
      reportActions.selectClear(id);
    }
  }
  handleSelectAll(event) {
    const _this$props2 = this.props,
      reportActions = _this$props2.reportActions,
      report = _this$props2.report;
    if (event && event.target.checked) {
      reportActions.selectAll(report.list.map(selected => selected.id));
    } else {
      reportActions.selectClearAll();
    }
  }
  render() {
    var _indexQuery$filters$m, _indexQuery$filters;
    const _this$props3 = this.props,
      report = _this$props3.report,
      userType = _this$props3.userType,
      username = _this$props3.username;
    const showAddModal = this.state.showAddModal;
    const _this$props4 = this.props,
      jobFilterAddActions = _this$props4.jobFilterAddActions,
      jobFilterAdd = _this$props4.jobFilterAdd,
      dynamicReportTypes = _this$props4.dynamicReportTypes,
      reportActions = _this$props4.reportActions,
      reportTypeFilterAddActions = _this$props4.reportTypeFilterAddActions,
      reportTypeFilterAdd = _this$props4.reportTypeFilterAdd,
      geolocation = _this$props4.geolocation,
      _this$props4$report = _this$props4.report,
      list = _this$props4$report.list,
      selected = _this$props4$report.selected,
      indexQuery = _this$props4$report.indexQuery,
      user = _this$props4.user;

    // Get metaDeleted filter value for bulk actions
    const metaDeleted = (_indexQuery$filters$m = indexQuery === null || indexQuery === void 0 || (_indexQuery$filters = indexQuery.filters) === null || _indexQuery$filters === void 0 ? void 0 : _indexQuery$filters.metaDeleted) !== null && _indexQuery$filters$m !== void 0 ? _indexQuery$filters$m : 0;

    // check to see if the actions are disabled/enabled via permissions
    const actionsEnabled = checkPermission({
      resourceIdentifier: 'report'
    }, 'actions', user.permissions, user) !== false;
    const showNew = actionsEnabled && dynamicReportTypes.list && dynamicReportTypes.list.length > 0 && getIsPermittedWithNoneOfThesePermissions(['read_only']);
    const showBulkActions = getIsPermittedWithNoneOfThesePermissions(['read_only']) && actionsEnabled;
    const readOnlyMode = getIsPermittedWithAnyOfThesePermissions(['report_read_only']);
    return /*#__PURE__*/React.createElement("div", null, showAddModal ? /*#__PURE__*/React.createElement(AddReportModal, {
      jobActions: jobFilterAddActions,
      jobs: jobFilterAdd.list,
      jobLoading: jobFilterAdd.loading,
      jobIndexQuery: jobFilterAdd.indexQuery,
      onHide: this.handleAddHide,
      reportActions: reportActions,
      reportTypeActions: reportTypeFilterAddActions,
      reportTypeIndexQuery: reportTypeFilterAdd.indexQuery,
      reportTypeLoading: reportTypeFilterAdd.loading,
      reportTypes: dynamicReportTypes.list,
      geolocation: geolocation
    }) : null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(ReportFilterPanel, null)), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(ListPanel, {
      actionButton: showBulkActions ? /*#__PURE__*/React.createElement(ReportsBulkActions, {
        metaDeleted: metaDeleted,
        username: username
      }) : null,
      onAdd: this.handleAdd,
      showNew: showNew,
      title: "File Cabinet"
    }, /*#__PURE__*/React.createElement(ReportPagingTable, {
      hideSortOptions: true,
      headers: [/*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        onChange: this.handleSelectAll
      }), 'Name', 'Creator', 'Status', ''],
      indexQuery: report.indexQuery,
      loading: report.loading
    }, list.map((nextReport, index) => /*#__PURE__*/React.createElement(ReportsRow, {
      index: index,
      key: "Report_".concat(nextReport.id),
      data: nextReport,
      onClick: this.handleClick,
      onEditClick: this.handleEditClick,
      onSelect: this.handleSelect,
      hasActions: true,
      readOnly: readOnlyMode && !isCreator(nextReport.appCreatorID),
      isSelected: _.contains(selected, nextReport.id),
      isDeleted: metaDeleted === 1,
      userType: userType
    }))))))));
  }
}
Reports.propTypes = {
  user: PropTypes.shape({
    permissions: PropTypes.shape({}),
    user_id: PropTypes.string
  }).isRequired,
  dynamicReportTypes: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  displaySettings: PropTypes.shape({
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  displaySettingsActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobFilterAdd: PropTypes.shape({
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  jobFilterAddActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  report: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool,
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool,
      filters: PropTypes.shape({
        metaDeleted: PropTypes.number
      }),
      paging: PropTypes.shape({
        current: PropTypes.number.isRequired
      }).isRequired,
      sortAttribute: PropTypes.string,
      sortDirection: PropTypes.string
    }).isRequired,
    newReportID: PropTypes.string,
    // set when new report is saved
    selected: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  reportActions: PropTypes.shape({
    select: PropTypes.func,
    selectAll: PropTypes.func,
    selectClear: PropTypes.func,
    selectClearAll: PropTypes.func,
    serverIndex: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  reportTypeFilterAdd: PropTypes.shape({
    loading: PropTypes.bool,
    indexQuery: PropTypes.shape({
      sortDirection: PropTypes.string
    }).isRequired
  }).isRequired,
  reportTypeFilterAddActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  geolocation: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  userType: PropTypes.string.isRequired,
  username: PropTypes.string
};
Reports.defaultProps = {
  username: ''
};